import  CD from 'toolConstants/classroomDesigner';
import  CRD from 'toolConstants/conferenceroomDesigner';
import  WD from 'toolConstants/warehouseDesigner';
import { camelCase } from 'lodash';

const toolIndex = [CRD, CD, WD].reduce((acc, cur) => {
  return({...acc, [camelCase(cur.constants.tool.fullName)]: cur})
}, {});

export default toolIndex;